export const arrival = {
    arrival_form: {
        PDBShipRef: "",
        VesselName: "",
        PortType: "",
        PortName: "",
        LaycanStartDate: null,
        LaycanEndDate: null,
        ATADate: "",
        ATATime: "",
        ATADateTime: null,
        DistanceTravelled: "",
        ROBMFO: "",
        ROBMGO: "",
        CreatedTimestamp:'',
        ModifiedTimestamp:'',
        ReportFilename: "Arrival",
        ModifyBy: "",
        ReportStatus:"",
        DateCreated: "",
        DateModify: "",
        ETADate:"",
        ETATime:"",
        ETADateTime:""
    },
    is_submit_loading:false,
    is_form_loading:false,
    date_change:{
        name:'',
        date:''
    },
    read_data:{},

}


// WEBPACK FOOTER //
// ./src/reducers/arrival/arrival.state.js